module.exports = __webpack_public_path__ + "static/2-1-4a9e3799d6aba7a991d97d55056c0ab6.gif";